module.exports = __webpack_public_path__ + "img/plan.28a58719.png";